import { capitalizeFirstName, capitalizeLastName, createCapitalizeHandler } from '@/shared/utils'
import type { PersonalInfoProps } from '@/features/enrollment'

export default function PFASPersonalInfo({ enrollmentData, updateEnrollmentData, errors }: PersonalInfoProps) {
  return (
    <>
      {/* Full Name of person signing retainer agreement */}
      <div>
        <label className="block text-sm font-medium text-accent-700 mb-2">
          Full Name of person signing retainer agreement
        </label>
        <input 
          type="text" 
          className="input-field bg-accent-100 cursor-not-allowed" 
          value={enrollmentData.retainerAgreementFullName || ''} 
          disabled 
        />
      </div>

      {/* Affected Person's Name */}
      <div>
        <label className="block text-sm font-medium text-accent-700 mb-2">
          AFFECTED PERSON'S NAME <span className="text-red-500">*</span>
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
          <div>
            <input 
              type="text" 
              name="injuredPartyFirstName"
              className={`input-field ${errors.injuredPartyFirstName ? 'border-red-500' : ''}`} 
              placeholder="First Name" 
              value={enrollmentData.injuredPartyFirstName || ''} 
              onChange={createCapitalizeHandler(
                (value) => updateEnrollmentData('injuredPartyFirstName', value),
                capitalizeFirstName
              )} 
            />
            <label className="block text-xs text-accent-500 mt-1">First Name</label>
            {errors.injuredPartyFirstName && (
              <p className="mt-1 text-sm text-red-600">{errors.injuredPartyFirstName}</p>
            )}
          </div>
          <div>
            <input 
              type="text" 
              className="input-field" 
              placeholder="Middle Name" 
              value={enrollmentData.injuredPartyMiddleName || ''} 
              onChange={createCapitalizeHandler(
                (value) => updateEnrollmentData('injuredPartyMiddleName', value),
                capitalizeFirstName
              )} 
            />
            <label className="block text-xs text-accent-500 mt-1">Middle Name (optional)</label>
          </div>
          <div>
            <input 
              type="text" 
              name="injuredPartyLastName"
              className={`input-field ${errors.injuredPartyLastName ? 'border-red-500' : ''}`} 
              placeholder="Last Name" 
              value={enrollmentData.injuredPartyLastName || ''} 
              onChange={createCapitalizeHandler(
                (value) => updateEnrollmentData('injuredPartyLastName', value),
                capitalizeLastName
              )} 
            />
            <label className="block text-xs text-accent-500 mt-1">Last Name</label>
            {errors.injuredPartyLastName && (
              <p className="mt-1 text-sm text-red-600">{errors.injuredPartyLastName}</p>
            )}
          </div>
          <div>
            <input 
              type="text" 
              className="input-field" 
              placeholder="Suffix" 
              value={enrollmentData.injuredPartySuffix || ''} 
              onChange={(e) => updateEnrollmentData('injuredPartySuffix', e.target.value)} 
            />
            <label className="block text-xs text-accent-500 mt-1">Suffix (optional)</label>
          </div>
        </div>
      </div>

      {/* Gender */}
      <div>
        <label className="block text-sm font-medium text-accent-700 mb-2">
          Gender <span className="text-red-500">*</span>
        </label>
        <select 
          className={`input-field ${errors.gender ? 'border-red-500' : ''}`} 
          value={enrollmentData.gender || ''} 
          onChange={(e) => updateEnrollmentData('gender', e.target.value)}
        >
          <option value="">Select Gender</option>
          <option value="MALE">Male</option>
          <option value="FEMALE">Female</option>
        </select>
        {errors.gender && (
          <p className="mt-1 text-sm text-red-600">{errors.gender}</p>
        )}
      </div>
    </>
  )
}
